import React from 'react'
import ReportAppContext from '../reportLayout/ReportAppContext'
const useReportApp = () => {
    return React.useContext(ReportAppContext)
}

export default useReportApp
